const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1,%20gostaria%20de%20informa%C3%A7%C3%B5es%20das%20m%C3%A1quinas.........";

export default function HeroSection() {
  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
      (window as any).gtag_report_conversion(WA_LINK, true);
    } else {
      window.open(WA_LINK, '_blank');
    }
  };

  const handleScrollToStock = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector('#stock');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[640px] max-h-[860px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Máquinas de solda geomembrana cunha quente para impermeabilização no Brasil"
          className="w-full h-full object-cover object-center"
          src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=912,fit=crop,f=jpeg/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-24 md:pt-0">
        <div className="max-w-xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1.5 mb-6 max-w-full">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse flex-shrink-0" />
            <span className="text-white/80 text-[10px] sm:text-xs font-bold tracking-wider uppercase leading-tight">
              Distribuidor Oficial — Brasil &amp; Argentina
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-none mb-5 uppercase">
            MÁQUINAS DE<br />
            <span className="text-green-400">SOLDA</span><br />
            GEOMEMBRANA<br />
            <span className="text-green-400">NO BRASIL</span>
          </h1>

          <p className="text-white/80 text-sm md:text-lg leading-relaxed mb-8 max-w-md">
            <strong className="text-white">Distribuidor oficial de máquinas de solda geomembrana no Brasil</strong> —
            cunha quente, extrusoras e acessórios para impermeabilização de PEAD, PELBD e PVC.
            Atendemos todo o território nacional e a Argentina, com suporte técnico pós-venda e garantia oficial.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              onClick={handleWhatsAppClick}
              className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-400 text-white font-black px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar no WhatsApp
            </a>
            <a
              href="#stock"
              onClick={handleScrollToStock}
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              Ver Catálogo
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="mt-8 flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 border border-white/20">
              <i className="ri-phone-line text-white text-sm" />
            </div>
            <span className="text-white/60 text-sm">
              <span className="text-white font-bold">48-91802091</span>
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 opacity-50">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white animate-bounce" />
      </div>
    </section>
  );
}
